module.exports = __webpack_public_path__ + "static/media/banner_1.f3a60488.jpg";